import { Box, Button, Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";
import EditIcon from "@mui/icons-material/Edit";
import {
  chartsReportStyles,
  chartConfig,
  xAxisConfig,
  yAxisConfig,
  seriesConfig,
} from "../../../styles/ChartsReport.styles";
import { useState, useMemo, useCallback } from "react";
import ChartDataModal, { ChartDataPoint } from "./ChartDataModal";

const ChartsReport = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataPoints, setDataPoints] = useState<ChartDataPoint[]>([]);

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleDataChange = useCallback((newDataPoints: ChartDataPoint[]) => {
    setDataPoints(newDataPoints);
  }, []);

  const xAxis = useMemo(
    () => [
      {
        dataKey: "date",
        ...xAxisConfig,
      },
    ],
    []
  );

  const yAxis = useMemo(
    () => [
      {
        id: "yAxis",
        ...yAxisConfig,
      },
    ],
    []
  );

  const series = useMemo(
    () => [
      {
        dataKey: "total",
        ...seriesConfig,
      },
    ],
    []
  );

  const hasData = dataPoints.length > 0;

  return (
    <Box sx={chartsReportStyles.chartContainer}>
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        sx={{ mt: 0.5, mb: 0.5}}
      >
        <Button
          variant="outlined"
          size="small"
          startIcon={<EditIcon />}
          onClick={handleOpenModal}
          aria-label="Edit chart data"
          tabIndex={0}
        >
          Edit Data ({dataPoints.length})
        </Button>
      </Box>

      {hasData ? (
        <LineChart
          xAxis={xAxis}
          yAxis={yAxis}
          series={series}
          dataset={dataPoints as unknown as { date: Date; total: number }[]}
          height={chartConfig.height}
          margin={chartConfig.margin}
        />
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          sx={{
            height: chartConfig.height - 50,
            border: "2px dashed #E0E0E0",
            borderRadius: 2,
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="body1" sx={{ color: "#666", mb: 2 }}>
            No data to display
          </Typography>
          <Button
            variant="contained"
            onClick={handleOpenModal}
            aria-label="Add chart data"
            tabIndex={0}
          >
            Add Data Points
          </Button>
        </Box>
      )}

      <ChartDataModal
        open={isModalOpen}
        onClose={handleCloseModal}
        dataPoints={dataPoints}
        onChange={handleDataChange}
      />
    </Box>
  );
};

export default ChartsReport;
